module.exports = __webpack_public_path__ + "img/bt_international.ff52676e.png";